import { Box, Flex, Text } from '@radix-ui/themes';
import type { SvgIconComponent } from '@mui/icons-material';

const numberFormatter = new Intl.NumberFormat('en-US');

export type StatInfoCardTone = 'blue' | 'orange' | 'teal' | 'green';

export type StatInfoCardDetail = {
   label: string;
   value: number;
};

export type StatInfoCardProps = {
   title: string;
   total: number;
   details: StatInfoCardDetail[];
   tone: StatInfoCardTone;
   icon: SvgIconComponent;
};

const formatNumber = (value: number) => numberFormatter.format(value);

export const StatInfoCard = ({ title, total, details, tone, icon: Icon }: StatInfoCardProps) => (
   <Box className={`main-analytics__stat main-analytics__stat--${tone}`}>
      <Box className="main-analytics__stat-top">
         <Box>
            <Text as="p" className="main-analytics__stat-title">
               {title}
            </Text>
            <Text as="p" className="main-analytics__stat-total">
               {formatNumber(total)}
            </Text>
         </Box>
         <Icon className="main-analytics__stat-icon" />
      </Box>

      <Box className="main-analytics__stat-details">
         {details.map((detail) => (
            <Flex key={detail.label} align="center" justify="between" gap="3">
               <Flex align="center" gap="2" minWidth="0">
                  <span className="main-analytics__dot" />
                  <Text className="main-analytics__detail-label">{detail.label}</Text>
               </Flex>
               <Text className="main-analytics__detail-value">
                  {formatNumber(detail.value)}
               </Text>
            </Flex>
         ))}
      </Box>
   </Box>
);
